module.exports = __webpack_public_path__ + "static/media/9.00d3ea5e.svg";